/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/giftcard/service.proto" (package "rd.api.giftcard", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Location } from "../../company/models_pb";
import { Customer } from "../../customer/models_pb";
import { GiftCardActivity_Type } from "../../giftcard/models_pb";
import { Money } from "../../proto/money/models_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Product } from "../../product/models_pb";
import { GiftCardBalance } from "../../giftcard/models_pb";
import { GiftCard } from "../../giftcard/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardReq
 */
export interface GetGiftCardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardRes
 */
export interface GetGiftCardRes {
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard gift_card = 1
     */
    giftCard?: GiftCard;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCardBalance gift_card_balance = 2
     */
    giftCardBalance?: GiftCardBalance;
    /**
     * @generated from protobuf field: rd.product.Product product = 3
     */
    product?: Product;
}
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardByNumberReq
 */
export interface GetGiftCardByNumberReq {
    /**
     * @generated from protobuf field: string card_number = 1
     */
    cardNumber: string;
}
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardByNumberRes
 */
export interface GetGiftCardByNumberRes {
    /**
     * @generated from protobuf field: rd.giftcard.GiftCard gift_card = 1
     */
    giftCard?: GiftCard;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCardBalance gift_card_balance = 2
     */
    giftCardBalance?: GiftCardBalance;
    /**
     * @generated from protobuf field: rd.product.Product product = 3
     */
    product?: Product;
}
/**
 * @generated from protobuf message rd.api.giftcard.ListGiftCardHistoryReq
 */
export interface ListGiftCardHistoryReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.ListGiftCardHistoryRes
 */
export interface ListGiftCardHistoryRes {
    /**
     * @generated from protobuf field: repeated rd.api.giftcard.ListGiftCardHistoryRes.Activity activities = 1
     */
    activities: ListGiftCardHistoryRes_Activity[];
}
/**
 * @generated from protobuf message rd.api.giftcard.ListGiftCardHistoryRes.Activity
 */
export interface ListGiftCardHistoryRes_Activity {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID ledger_entry_id = 1
     */
    ledgerEntryId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money net_amount = 3
     */
    netAmount?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money running_balance = 4
     */
    runningBalance?: Money;
    /**
     * @generated from protobuf field: rd.giftcard.GiftCardActivity.Type type = 5
     */
    type: GiftCardActivity_Type;
    /**
     * @generated from protobuf field: string identifier = 6
     */
    identifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID sale_id = 7
     */
    saleId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID bill_payment_id = 8
     */
    billPaymentId?: UUID;
    /**
     * @generated from protobuf field: rd.customer.Customer customer = 9
     */
    customer?: Customer;
    /**
     * @generated from protobuf field: rd.company.Location location = 10
     */
    location?: Location;
}
/**
 * @generated from protobuf message rd.api.giftcard.BulkGenerateGiftCardNumbersReq
 */
export interface BulkGenerateGiftCardNumbersReq {
    /**
     * @generated from protobuf field: int32 count = 1
     */
    count: number;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.BulkGenerateGiftCardNumbersRes
 */
export interface BulkGenerateGiftCardNumbersRes {
    /**
     * @generated from protobuf field: bytes excel_bytes = 1
     */
    excelBytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.giftcard.BulkImportGiftCardNumbersReq
 */
export interface BulkImportGiftCardNumbersReq {
    /**
     * @generated from protobuf field: string file_url = 1
     */
    fileUrl: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID product_id = 2
     */
    productId?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.BulkImportGiftCardNumbersRes
 */
export interface BulkImportGiftCardNumbersRes {
}
/**
 * @generated from protobuf message rd.api.giftcard.DeactivateGiftCardReq
 */
export interface DeactivateGiftCardReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.DeactivateGiftCardRes
 */
export interface DeactivateGiftCardRes {
}
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardHistoryPDFReq
 */
export interface GetGiftCardHistoryPDFReq {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * @generated from protobuf message rd.api.giftcard.GetGiftCardHistoryPDFRes
 */
export interface GetGiftCardHistoryPDFRes {
    /**
     * @generated from protobuf field: bytes bytes = 1
     */
    bytes: Uint8Array;
}
/**
 * @generated from protobuf message rd.api.giftcard.SellGiftCardAtDifferentPriceReq
 */
export interface SellGiftCardAtDifferentPriceReq {
}
/**
 * @generated from protobuf message rd.api.giftcard.SellGiftCardAtDifferentPriceRes
 */
export interface SellGiftCardAtDifferentPriceRes {
}
/**
 * @generated from protobuf message rd.api.giftcard.EnableOrDisableGiftCardsReq
 */
export interface EnableOrDisableGiftCardsReq {
    /**
     * @generated from protobuf field: bool is_enabled = 1
     */
    isEnabled: boolean;
}
/**
 * @generated from protobuf message rd.api.giftcard.EnableOrDisableGiftCardsRes
 */
export interface EnableOrDisableGiftCardsRes {
}
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardReq$Type extends MessageType<GetGiftCardReq> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardReq>): GetGiftCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardReq): GetGiftCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardReq
 */
export const GetGiftCardReq = new GetGiftCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardRes$Type extends MessageType<GetGiftCardRes> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardRes", [
            { no: 1, name: "gift_card", kind: "message", T: () => GiftCard },
            { no: 2, name: "gift_card_balance", kind: "message", T: () => GiftCardBalance },
            { no: 3, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardRes>): GetGiftCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardRes): GetGiftCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.giftcard.GiftCard gift_card */ 1:
                    message.giftCard = GiftCard.internalBinaryRead(reader, reader.uint32(), options, message.giftCard);
                    break;
                case /* rd.giftcard.GiftCardBalance gift_card_balance */ 2:
                    message.giftCardBalance = GiftCardBalance.internalBinaryRead(reader, reader.uint32(), options, message.giftCardBalance);
                    break;
                case /* rd.product.Product product */ 3:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.giftcard.GiftCard gift_card = 1; */
        if (message.giftCard)
            GiftCard.internalBinaryWrite(message.giftCard, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCardBalance gift_card_balance = 2; */
        if (message.giftCardBalance)
            GiftCardBalance.internalBinaryWrite(message.giftCardBalance, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 3; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardRes
 */
export const GetGiftCardRes = new GetGiftCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardByNumberReq$Type extends MessageType<GetGiftCardByNumberReq> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardByNumberReq", [
            { no: 1, name: "card_number", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.sanitize.log": true, "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardByNumberReq>): GetGiftCardByNumberReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cardNumber = "";
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardByNumberReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardByNumberReq): GetGiftCardByNumberReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string card_number */ 1:
                    message.cardNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardByNumberReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string card_number = 1; */
        if (message.cardNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.cardNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardByNumberReq
 */
export const GetGiftCardByNumberReq = new GetGiftCardByNumberReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardByNumberRes$Type extends MessageType<GetGiftCardByNumberRes> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardByNumberRes", [
            { no: 1, name: "gift_card", kind: "message", T: () => GiftCard },
            { no: 2, name: "gift_card_balance", kind: "message", T: () => GiftCardBalance },
            { no: 3, name: "product", kind: "message", T: () => Product }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardByNumberRes>): GetGiftCardByNumberRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardByNumberRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardByNumberRes): GetGiftCardByNumberRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.giftcard.GiftCard gift_card */ 1:
                    message.giftCard = GiftCard.internalBinaryRead(reader, reader.uint32(), options, message.giftCard);
                    break;
                case /* rd.giftcard.GiftCardBalance gift_card_balance */ 2:
                    message.giftCardBalance = GiftCardBalance.internalBinaryRead(reader, reader.uint32(), options, message.giftCardBalance);
                    break;
                case /* rd.product.Product product */ 3:
                    message.product = Product.internalBinaryRead(reader, reader.uint32(), options, message.product);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardByNumberRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.giftcard.GiftCard gift_card = 1; */
        if (message.giftCard)
            GiftCard.internalBinaryWrite(message.giftCard, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCardBalance gift_card_balance = 2; */
        if (message.giftCardBalance)
            GiftCardBalance.internalBinaryWrite(message.giftCardBalance, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.product.Product product = 3; */
        if (message.product)
            Product.internalBinaryWrite(message.product, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardByNumberRes
 */
export const GetGiftCardByNumberRes = new GetGiftCardByNumberRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGiftCardHistoryReq$Type extends MessageType<ListGiftCardHistoryReq> {
    constructor() {
        super("rd.api.giftcard.ListGiftCardHistoryReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<ListGiftCardHistoryReq>): ListGiftCardHistoryReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ListGiftCardHistoryReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListGiftCardHistoryReq): ListGiftCardHistoryReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListGiftCardHistoryReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.ListGiftCardHistoryReq
 */
export const ListGiftCardHistoryReq = new ListGiftCardHistoryReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGiftCardHistoryRes$Type extends MessageType<ListGiftCardHistoryRes> {
    constructor() {
        super("rd.api.giftcard.ListGiftCardHistoryRes", [
            { no: 1, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListGiftCardHistoryRes_Activity }
        ]);
    }
    create(value?: PartialMessage<ListGiftCardHistoryRes>): ListGiftCardHistoryRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.activities = [];
        if (value !== undefined)
            reflectionMergePartial<ListGiftCardHistoryRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListGiftCardHistoryRes): ListGiftCardHistoryRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.api.giftcard.ListGiftCardHistoryRes.Activity activities */ 1:
                    message.activities.push(ListGiftCardHistoryRes_Activity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListGiftCardHistoryRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.api.giftcard.ListGiftCardHistoryRes.Activity activities = 1; */
        for (let i = 0; i < message.activities.length; i++)
            ListGiftCardHistoryRes_Activity.internalBinaryWrite(message.activities[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.ListGiftCardHistoryRes
 */
export const ListGiftCardHistoryRes = new ListGiftCardHistoryRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGiftCardHistoryRes_Activity$Type extends MessageType<ListGiftCardHistoryRes_Activity> {
    constructor() {
        super("rd.api.giftcard.ListGiftCardHistoryRes.Activity", [
            { no: 1, name: "ledger_entry_id", kind: "message", T: () => UUID },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp },
            { no: 3, name: "net_amount", kind: "message", T: () => Money },
            { no: 4, name: "running_balance", kind: "message", T: () => Money },
            { no: 5, name: "type", kind: "enum", T: () => ["rd.giftcard.GiftCardActivity.Type", GiftCardActivity_Type, "TYPE_"] },
            { no: 6, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "sale_id", kind: "message", T: () => UUID },
            { no: 8, name: "bill_payment_id", kind: "message", T: () => UUID },
            { no: 9, name: "customer", kind: "message", T: () => Customer },
            { no: 10, name: "location", kind: "message", T: () => Location }
        ]);
    }
    create(value?: PartialMessage<ListGiftCardHistoryRes_Activity>): ListGiftCardHistoryRes_Activity {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<ListGiftCardHistoryRes_Activity>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListGiftCardHistoryRes_Activity): ListGiftCardHistoryRes_Activity {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID ledger_entry_id */ 1:
                    message.ledgerEntryId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.ledgerEntryId);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* rd.proto.money.Money net_amount */ 3:
                    message.netAmount = Money.internalBinaryRead(reader, reader.uint32(), options, message.netAmount);
                    break;
                case /* rd.proto.money.Money running_balance */ 4:
                    message.runningBalance = Money.internalBinaryRead(reader, reader.uint32(), options, message.runningBalance);
                    break;
                case /* rd.giftcard.GiftCardActivity.Type type */ 5:
                    message.type = reader.int32();
                    break;
                case /* string identifier */ 6:
                    message.identifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID sale_id */ 7:
                    message.saleId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.saleId);
                    break;
                case /* rd.proto.uuid.UUID bill_payment_id */ 8:
                    message.billPaymentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.billPaymentId);
                    break;
                case /* rd.customer.Customer customer */ 9:
                    message.customer = Customer.internalBinaryRead(reader, reader.uint32(), options, message.customer);
                    break;
                case /* rd.company.Location location */ 10:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListGiftCardHistoryRes_Activity, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID ledger_entry_id = 1; */
        if (message.ledgerEntryId)
            UUID.internalBinaryWrite(message.ledgerEntryId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money net_amount = 3; */
        if (message.netAmount)
            Money.internalBinaryWrite(message.netAmount, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money running_balance = 4; */
        if (message.runningBalance)
            Money.internalBinaryWrite(message.runningBalance, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.giftcard.GiftCardActivity.Type type = 5; */
        if (message.type !== 0)
            writer.tag(5, WireType.Varint).int32(message.type);
        /* string identifier = 6; */
        if (message.identifier !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.identifier);
        /* rd.proto.uuid.UUID sale_id = 7; */
        if (message.saleId)
            UUID.internalBinaryWrite(message.saleId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID bill_payment_id = 8; */
        if (message.billPaymentId)
            UUID.internalBinaryWrite(message.billPaymentId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.customer.Customer customer = 9; */
        if (message.customer)
            Customer.internalBinaryWrite(message.customer, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Location location = 10; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.ListGiftCardHistoryRes.Activity
 */
export const ListGiftCardHistoryRes_Activity = new ListGiftCardHistoryRes_Activity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGenerateGiftCardNumbersReq$Type extends MessageType<BulkGenerateGiftCardNumbersReq> {
    constructor() {
        super("rd.api.giftcard.BulkGenerateGiftCardNumbersReq", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "rd.validator.require": true } },
            { no: 2, name: "product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<BulkGenerateGiftCardNumbersReq>): BulkGenerateGiftCardNumbersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<BulkGenerateGiftCardNumbersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGenerateGiftCardNumbersReq): BulkGenerateGiftCardNumbersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 count */ 1:
                    message.count = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGenerateGiftCardNumbersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int32(message.count);
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.BulkGenerateGiftCardNumbersReq
 */
export const BulkGenerateGiftCardNumbersReq = new BulkGenerateGiftCardNumbersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGenerateGiftCardNumbersRes$Type extends MessageType<BulkGenerateGiftCardNumbersRes> {
    constructor() {
        super("rd.api.giftcard.BulkGenerateGiftCardNumbersRes", [
            { no: 1, name: "excel_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<BulkGenerateGiftCardNumbersRes>): BulkGenerateGiftCardNumbersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.excelBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<BulkGenerateGiftCardNumbersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGenerateGiftCardNumbersRes): BulkGenerateGiftCardNumbersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes excel_bytes */ 1:
                    message.excelBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGenerateGiftCardNumbersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes excel_bytes = 1; */
        if (message.excelBytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.excelBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.BulkGenerateGiftCardNumbersRes
 */
export const BulkGenerateGiftCardNumbersRes = new BulkGenerateGiftCardNumbersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkImportGiftCardNumbersReq$Type extends MessageType<BulkImportGiftCardNumbersReq> {
    constructor() {
        super("rd.api.giftcard.BulkImportGiftCardNumbersReq", [
            { no: 1, name: "file_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "rd.validator.require": true } },
            { no: 2, name: "product_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<BulkImportGiftCardNumbersReq>): BulkImportGiftCardNumbersReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fileUrl = "";
        if (value !== undefined)
            reflectionMergePartial<BulkImportGiftCardNumbersReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkImportGiftCardNumbersReq): BulkImportGiftCardNumbersReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string file_url */ 1:
                    message.fileUrl = reader.string();
                    break;
                case /* rd.proto.uuid.UUID product_id */ 2:
                    message.productId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.productId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkImportGiftCardNumbersReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string file_url = 1; */
        if (message.fileUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fileUrl);
        /* rd.proto.uuid.UUID product_id = 2; */
        if (message.productId)
            UUID.internalBinaryWrite(message.productId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.BulkImportGiftCardNumbersReq
 */
export const BulkImportGiftCardNumbersReq = new BulkImportGiftCardNumbersReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkImportGiftCardNumbersRes$Type extends MessageType<BulkImportGiftCardNumbersRes> {
    constructor() {
        super("rd.api.giftcard.BulkImportGiftCardNumbersRes", []);
    }
    create(value?: PartialMessage<BulkImportGiftCardNumbersRes>): BulkImportGiftCardNumbersRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BulkImportGiftCardNumbersRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkImportGiftCardNumbersRes): BulkImportGiftCardNumbersRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkImportGiftCardNumbersRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.BulkImportGiftCardNumbersRes
 */
export const BulkImportGiftCardNumbersRes = new BulkImportGiftCardNumbersRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateGiftCardReq$Type extends MessageType<DeactivateGiftCardReq> {
    constructor() {
        super("rd.api.giftcard.DeactivateGiftCardReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } }
        ]);
    }
    create(value?: PartialMessage<DeactivateGiftCardReq>): DeactivateGiftCardReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateGiftCardReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateGiftCardReq): DeactivateGiftCardReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateGiftCardReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.DeactivateGiftCardReq
 */
export const DeactivateGiftCardReq = new DeactivateGiftCardReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeactivateGiftCardRes$Type extends MessageType<DeactivateGiftCardRes> {
    constructor() {
        super("rd.api.giftcard.DeactivateGiftCardRes", []);
    }
    create(value?: PartialMessage<DeactivateGiftCardRes>): DeactivateGiftCardRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeactivateGiftCardRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeactivateGiftCardRes): DeactivateGiftCardRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeactivateGiftCardRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.DeactivateGiftCardRes
 */
export const DeactivateGiftCardRes = new DeactivateGiftCardRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardHistoryPDFReq$Type extends MessageType<GetGiftCardHistoryPDFReq> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardHistoryPDFReq", [
            { no: 1, name: "id", kind: "message", T: () => UUID, options: { "rd.validator.require": true } },
            { no: 2, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardHistoryPDFReq>): GetGiftCardHistoryPDFReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardHistoryPDFReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardHistoryPDFReq): GetGiftCardHistoryPDFReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardHistoryPDFReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardHistoryPDFReq
 */
export const GetGiftCardHistoryPDFReq = new GetGiftCardHistoryPDFReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGiftCardHistoryPDFRes$Type extends MessageType<GetGiftCardHistoryPDFRes> {
    constructor() {
        super("rd.api.giftcard.GetGiftCardHistoryPDFRes", [
            { no: 1, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<GetGiftCardHistoryPDFRes>): GetGiftCardHistoryPDFRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<GetGiftCardHistoryPDFRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetGiftCardHistoryPDFRes): GetGiftCardHistoryPDFRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes bytes */ 1:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetGiftCardHistoryPDFRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes bytes = 1; */
        if (message.bytes.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.GetGiftCardHistoryPDFRes
 */
export const GetGiftCardHistoryPDFRes = new GetGiftCardHistoryPDFRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellGiftCardAtDifferentPriceReq$Type extends MessageType<SellGiftCardAtDifferentPriceReq> {
    constructor() {
        super("rd.api.giftcard.SellGiftCardAtDifferentPriceReq", []);
    }
    create(value?: PartialMessage<SellGiftCardAtDifferentPriceReq>): SellGiftCardAtDifferentPriceReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SellGiftCardAtDifferentPriceReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SellGiftCardAtDifferentPriceReq): SellGiftCardAtDifferentPriceReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SellGiftCardAtDifferentPriceReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.SellGiftCardAtDifferentPriceReq
 */
export const SellGiftCardAtDifferentPriceReq = new SellGiftCardAtDifferentPriceReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SellGiftCardAtDifferentPriceRes$Type extends MessageType<SellGiftCardAtDifferentPriceRes> {
    constructor() {
        super("rd.api.giftcard.SellGiftCardAtDifferentPriceRes", []);
    }
    create(value?: PartialMessage<SellGiftCardAtDifferentPriceRes>): SellGiftCardAtDifferentPriceRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<SellGiftCardAtDifferentPriceRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SellGiftCardAtDifferentPriceRes): SellGiftCardAtDifferentPriceRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SellGiftCardAtDifferentPriceRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.SellGiftCardAtDifferentPriceRes
 */
export const SellGiftCardAtDifferentPriceRes = new SellGiftCardAtDifferentPriceRes$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableOrDisableGiftCardsReq$Type extends MessageType<EnableOrDisableGiftCardsReq> {
    constructor() {
        super("rd.api.giftcard.EnableOrDisableGiftCardsReq", [
            { no: 1, name: "is_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<EnableOrDisableGiftCardsReq>): EnableOrDisableGiftCardsReq {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isEnabled = false;
        if (value !== undefined)
            reflectionMergePartial<EnableOrDisableGiftCardsReq>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnableOrDisableGiftCardsReq): EnableOrDisableGiftCardsReq {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool is_enabled */ 1:
                    message.isEnabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnableOrDisableGiftCardsReq, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool is_enabled = 1; */
        if (message.isEnabled !== false)
            writer.tag(1, WireType.Varint).bool(message.isEnabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.EnableOrDisableGiftCardsReq
 */
export const EnableOrDisableGiftCardsReq = new EnableOrDisableGiftCardsReq$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnableOrDisableGiftCardsRes$Type extends MessageType<EnableOrDisableGiftCardsRes> {
    constructor() {
        super("rd.api.giftcard.EnableOrDisableGiftCardsRes", []);
    }
    create(value?: PartialMessage<EnableOrDisableGiftCardsRes>): EnableOrDisableGiftCardsRes {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<EnableOrDisableGiftCardsRes>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnableOrDisableGiftCardsRes): EnableOrDisableGiftCardsRes {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnableOrDisableGiftCardsRes, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.api.giftcard.EnableOrDisableGiftCardsRes
 */
export const EnableOrDisableGiftCardsRes = new EnableOrDisableGiftCardsRes$Type();
/**
 * @generated ServiceType for protobuf service rd.api.giftcard.GiftCardService
 */
export const GiftCardService = new ServiceType("rd.api.giftcard.GiftCardService", [
    { name: "GetGiftCard", options: {}, I: GetGiftCardReq, O: GetGiftCardRes },
    { name: "GetGiftCardByNumber", options: {}, I: GetGiftCardByNumberReq, O: GetGiftCardByNumberRes },
    { name: "ListGiftCardHistory", options: {}, I: ListGiftCardHistoryReq, O: ListGiftCardHistoryRes },
    { name: "BulkGenerateGiftCardNumbers", options: {}, I: BulkGenerateGiftCardNumbersReq, O: BulkGenerateGiftCardNumbersRes },
    { name: "BulkImportGiftCardNumbers", options: {}, I: BulkImportGiftCardNumbersReq, O: BulkImportGiftCardNumbersRes },
    { name: "DeactivateGiftCard", options: {}, I: DeactivateGiftCardReq, O: DeactivateGiftCardRes },
    { name: "GetGiftCardHistoryPDF", options: {}, I: GetGiftCardHistoryPDFReq, O: GetGiftCardHistoryPDFRes },
    { name: "SellGiftCardAtDifferentPrice", options: {}, I: SellGiftCardAtDifferentPriceReq, O: SellGiftCardAtDifferentPriceRes },
    { name: "EnableOrDisableGiftCards", options: {}, I: EnableOrDisableGiftCardsReq, O: EnableOrDisableGiftCardsRes }
]);
